import { render, staticRenderFns } from "./b_table_filter_pager.vue?vue&type=template&id=55868eb0&scoped=true&"
import script from "./b_table_filter_pager.vue?vue&type=script&lang=js&"
export * from "./b_table_filter_pager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55868eb0",
  null
  
)

export default component.exports